import {__} from "~/ts/library/Translate";
import ElNotify from "~/core-ui/vue/ui/ElNotify";

export const copyToClipboard = (str: string) => {
    const el = document.createElement('textarea');
    el.value = str;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
};


export function copyToClipboardWithNotification(str: string) {
    navigator.clipboard.writeText(str).then(() => {
        ElNotify.success({
            title: __('Скопировано в буфер обмена'),
            duration: 2000,
            message: undefined
        });
    }, () => {
        ElNotify.error({
            title: __('Не удалось скопировать в буфер обмена'),
            duration: 2000,
            message: undefined
        });
    });
}